import {
  PanelCard,
  SelectField,
  ToggleField,
} from './panelUi'
import { getSetting, type UserSettings } from './useUserSettings'
import { useWriteSettings } from './useWriteSettings'

/**
 * Appearance settings — matches the desktop Settings > Appearance & Playback
 * section, minus desktop-only controls (default video player, grid item
 * size is excluded since the PWA layout is fluid).
 */
export function AppearanceSettingsPanel({
  settings,
}: {
  settings: UserSettings | null
}) {
  const { updateSetting } = useWriteSettings()

  const theme = getSetting(settings, 'theme')
  const speed = getSetting(settings, 'animationSpeed')
  const showRatings = getSetting(settings, 'showMovieRatings')
  const showDuration = getSetting(settings, 'showMovieDuration')

  return (
    <PanelCard title="Appearance">
      <SelectField
        label="Theme"
        value={theme ?? 'dark'}
        options={[
          { value: 'dark', label: 'Dark' },
          { value: 'light', label: 'Light' },
        ]}
        onChange={(v) => updateSetting('theme', v)}
      />

      <SelectField
        label="Animation speed"
        value={speed ?? 'normal'}
        options={[
          { value: 'slow', label: 'Slow' },
          { value: 'normal', label: 'Normal' },
          { value: 'fast', label: 'Fast' },
          { value: 'none', label: 'No animations' },
        ]}
        onChange={(v) => updateSetting('animationSpeed', v)}
      />

      <ToggleField
        label="Show movie ratings"
        description="Display rating badges on movie cards"
        checked={Boolean(showRatings)}
        onChange={(v) => updateSetting('showMovieRatings', v)}
      />

      <ToggleField
        label="Show movie duration"
        description="Display movie duration on cards"
        checked={Boolean(showDuration)}
        onChange={(v) => updateSetting('showMovieDuration', v)}
      />
    </PanelCard>
  )
}
